export const theme = {
  typography: {
    heading: "2rem",
    subheading: "1.2rem",
    hint: "1.1rem",
  },
  spacing: 20,
} as const;
